import LocalStoragePersist from './persist/LocalStoragePersist.mjs';
import SessionStoragePersist from './persist/SessionStoragePersist.mjs';

const applyPersist = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let addCallbacks = arguments.length > 1 ? arguments[1] : undefined;
  let initialState = arguments.length > 2 ? arguments[2] : undefined;
  let persistStore = null;
  if (options?.persist) {
    const key = options.persist.key;
    if (options.persist.type === 'localStorage') {
      persistStore = new LocalStoragePersist(key, initialState, options.persist.typeAssertion);
      addCallbacks();
    }
    if (options.persist.type === 'sessionStorage') {
      persistStore = new SessionStoragePersist(key, initialState, options.persist.typeAssertion);
      addCallbacks();
    }
  }
  return persistStore;
};

export { applyPersist };
